// extracted by mini-css-extract-plugin
export default {"container":"NoteItem_container__xZ1lS","editButton":"NoteItem_editButton__xD6VA"};